class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    // this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.overlay = this.querySelector('#CartDrawer-Overlay');
    this.drawer = this.querySelector('#CartDrawer');
    this.addEventListener('click', (event) => {
      if (event.target.closest('#CartDrawer-Overlay')) this.close();
    });
    this.setHeaderCartIconAccessibility();
  }

  rebindDrawerElements() {
    this.overlay = this.querySelector('#CartDrawer-Overlay');
    this.drawer = this.querySelector('#CartDrawer');
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    this.querySelector('cart-drawer-marquee')?.startAutoPlay();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    this.querySelector('cart-drawer-marquee')?.stopAutoPlay();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState, options = {}) {
    const shouldOpen = options.open !== false;
    this.classList.toggle('is-empty', parsedState.item_count === 0);
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      // const sectionElement = section.selector
      //   ? document.querySelector(section.selector)
      //   : document.getElementById(section.id);
      let sectionElement;

      switch (section.id) {
        case 'cart-drawer':
          sectionElement = this.drawer;
          break;

        case 'cart-icon-bubble':
          sectionElement = document.getElementById('cart-icon-bubble');
          break;

        default:
          sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
      }

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    this.rebindDrawerElements();

    const drawerItems = this.querySelector('cart-drawer-items');
    if (drawerItems) {
      drawerItems.classList.toggle('is-empty', parsedState.item_count === 0);
    }

    if (shouldOpen) {
      setTimeout(() => {
        // this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.open();
      });
    }

    if (typeof window.__fsSyncProgress === 'function') {
      window.__fsSyncProgress(parsedState);
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

class CartDrawerMarquee extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.intervalId = null;
    this.isPaused = false;
    this.autoPlayDelay = 4000;
    this.onDotClick = this.onDotClick.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
  }

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-marquee-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-marquee-dot]'));

    if (this.slides.length < 2) return;

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', this.onDotClick);
      dot.dataset.marqueeIndex = String(index);
    });

    this.addEventListener('mouseenter', this.onMouseEnter);
    this.addEventListener('mouseleave', this.onMouseLeave);

    this.goTo(this.currentIndex);

    if (this.closest('cart-drawer')?.classList.contains('active')) {
      this.startAutoPlay();
    }
  }

  disconnectedCallback() {
    this.stopAutoPlay();
    this.dots?.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);
  }

  onDotClick(event) {
    const index = Number(event.currentTarget.dataset.marqueeIndex);
    if (Number.isNaN(index)) return;
    this.goTo(index);
    this.startAutoPlay();
  }

  onMouseEnter() {
    this.isPaused = true;
    this.stopAutoPlay();
  }

  onMouseLeave() {
    this.isPaused = false;
    this.startAutoPlay();
  }

  goTo(index) {
    this.currentIndex = ((index % this.slides.length) + this.slides.length) % this.slides.length;

    this.slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === this.currentIndex);
    });

    this.dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === this.currentIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  startAutoPlay() {
    if (this.isPaused || this.slides?.length < 2) return;

    this.stopAutoPlay();
    this.intervalId = window.setInterval(() => {
      this.goTo(this.currentIndex + 1);
    }, this.autoPlayDelay);
  }

  stopAutoPlay() {
    if (this.intervalId) {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}

customElements.define('cart-drawer-marquee', CartDrawerMarquee);
